// extracted by mini-css-extract-plugin
export default {"mapMain":"map-view_mapMain__31Ye3","mini":"map-view_mini__VAiPW","street":"map-view_street__fj4pU"};